import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <img {...{
      "src": "./../images/ibm/app-mgt.gif",
      "alt": "ibm"
    }}></img>
    <p>{`In this chapter you will:`}</p>
    <ul>
      <li parentName="ul">{`Integrate CP4AIOPS with `}<inlineCode parentName="li">{`OpenLDAP`}</inlineCode>{` for user management`}</li>
      <li parentName="ul">{`Integrate CP4AIOPS with `}<inlineCode parentName="li">{`ELK`}</inlineCode>{` for Log Anomalies`}</li>
      <li parentName="ul">{`Define and train `}<inlineCode parentName="li">{`AI Models`}</inlineCode>{` for`}
        <ul parentName="li">
          <li parentName="ul">{`Log Anomaly Detectiom`}</li>
          <li parentName="ul">{`Metric Anomaly Detection`}</li>
          <li parentName="ul">{`Event Grouping`}</li>
          <li parentName="ul">{`Similar Incidents`}</li>
          <li parentName="ul">{`Change Risk `}</li>
        </ul>
      </li>
      <li parentName="ul">{`Create `}<inlineCode parentName="li">{`Policies`}</inlineCode>{` for Story creation and Runbook assignment`}</li>
      <li parentName="ul">{`Integrate CP4AIOPS with `}<inlineCode parentName="li">{`Ansible Tower`}</inlineCode>{` and create Runbooks in CP4AIOPS`}</li>
      <li parentName="ul">{`Create a RobotShop Application `}<inlineCode parentName="li">{`Topology`}</inlineCode></li>
      <li parentName="ul">{`Integrate CP4AIOPS with `}<inlineCode parentName="li">{`Slack`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      